import React from 'react';
import { withTranslation } from 'react-i18next';
import { SETTINGS } from 'refactored/features/emergencies/constants';
import BodyColumn from 'refactored/features/emergencies/ui/columns/body-column';
import RegularText from 'refactored/features/emergencies/ui/texts/regular-text';
import styled from 'styled-components';

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  text-align: center;
  color: var(--grey700);
`;
const convertLoadTypeToLabel = (load_type, t) => {
  const available_load_types = [
    {
      value: 'eupallet',
      label: t('eu_pallet'),
    },
    {
      value: 'americanpallet',
      label: t('american_pallet'),
    },
    {
      value: 'cage',
      label: t('cage'),
    },
    {
      value: 'envelope',
      label: t('envelope'),
    },
    {
      value: 'box',
      label: t('box'),
    },
    {
      value: 'suitcase',
      label: t('suitcase'),
    },
    {
      value: 'drum',
      label: t('drum'),
    },
    {
      value: 'aero',
      label: t('aero'),
    },
    {
      value: 'rolls',
      label: t('rolls'),
    },
    {
      value: 'others',
      label: t('others'),
    },
  ];
  const existing_load_type = available_load_types.find(
    (item) => item.value === load_type
  );
  if (!!existing_load_type) return existing_load_type.label;
  return 'Unknown';
};

const LoadColumn = ({ ticket, t }) => {
  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.LOAD}
    >
      {ticket.order_data.loads_data.loads.map((load, index) => (
        <div key={index}>
          <CustomRegularText>
            {load.number_of_items} {convertLoadTypeToLabel(load.load_type, t)}
          </CustomRegularText>
        </div>
      ))}
    </BodyColumn>
  );
};

export default withTranslation('Emergencies')(LoadColumn);
